module.exports = __webpack_public_path__ + "img/404.8d8b1d33.svg";